(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupsSearchDataStore', ['$q', 'smbContentTypeGroupsSearchService', contentTypeGroupsSearchDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupsDataStore
	 * 
	 * @description
	 * A data store for managing local content type groups state for
	 * the configuration section.
	 */
	function contentTypeGroupsSearchDataStore($q, smbContentTypeGroupsSearchService) {
		var _allGroups;
		var _fullAccessGroups;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypeGroupsDataStore#groups
			 * @propertyOf smb-app.smbContentTypeGroupsDataStore
			 * @kind property
			 * 
			 * @description
			 * An array of all content type groups in the system.
			 */
			get allGroups() { return _allGroups; },

			get fullAccessGroups() { return _fullAccessGroups; },

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupsDataStore#loadGroups
			 * @methodOf smb-app.smbContentTypeGroupsDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads all content type groups from the API.
			 * 
			 * @returns {Promise} A promise that resolves to an array of all content type groups in the system.
			 */
			loadAllGroups: loadAllGroups,

			loadFullAccessGroups: loadFullAccessGroups
		};

		function loadAllGroups() {
			return smbContentTypeGroupsSearchService.getAllContentTypeGroups()
				.then(function (groups) {
					return groups.map(function mapLibraryDetails(lib) {
						return {
							id: lib.LibraryId,
							name: lib.LibraryName,
							icon: lib.IconName,
							links: {
								self: lib.Links.Self,
								icon: lib.Links.IconUri
							}
						};
					});
				})
				.then(function (groups) {
					_allGroups = groups;
					return groups;
				});
		}

		function loadFullAccessGroups() {
			return smbContentTypeGroupsSearchService.getFullAccessContentTypeGroups()
				.then(function (groups) {
					return groups.map(function mapLibraryDetails(lib) {
						return {
							id: lib.LibraryId,
							name: lib.LibraryName,
							icon: lib.IconName,
							links: {
								self: lib.Links.Self,
								icon: lib.Links.IconUri
							}
						};
					});
				})
				.then(function (groups) {
					_fullAccessGroups = groups;
					return groups;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentTypeGroupsSearchDataStore.js
// module id = 114
// module chunks = 1